import React, { useState } from 'react'
import { Box } from '@mui/material'
import {
  GridColumns,
  GridEventListener,
  GridRowModel,
  GridRowModesModel,
  GridRowParams,
  MuiEvent
} from '@mui/x-data-grid'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'
//import { v4 as uuidv4 } from 'uuid'

//temporarily disabling edit/delete functions
// function EditToolbar(props: EditToolbarProps) {
//   const { setRows, setRowModesModel } = props

//   const handleClick = () => {
//     const id = uuidv4()

//     setRows((oldRows) => [
//       ...oldRows,
//       {
//         expiry: '',
//         promo_code: '',
//         currency: '',
//         value: '',
//         symbol: '',
//         partner_name: ''
//       }
//     ])

//     setRowModesModel((oldModel) => ({
//       ...oldModel,
//       [id]: { mode: GridRowModes.Edit, fieldToFocus: 'value' }
//     }))
//   }

//   return (
//     <GridToolbarContainer>
//       <Button
//         color='primary'
//         disabled
//         startIcon={<AddIcon />}
//         onClick={handleClick}
//       >
//         Add record
//       </Button>
//     </GridToolbarContainer>
//   )
// }

// TODO: update for correct schema
export default function VouchersUploadDataGrid(props: ICRUDDataGrid) {
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({})
  const { rows, setRows } = props

  const handleRowEditStart = (
    params: GridRowParams,
    event: MuiEvent<React.SyntheticEvent>
  ) => {
    event.defaultMuiPrevented = true
  }

  const handleRowEditStop: GridEventListener<'rowEditStop'> = (
    params,
    event
  ) => {
    event.defaultMuiPrevented = true
  }
  //temporarily disabling edit/delete functions
  // const handleEditClick = (id: GridRowId) => () => {
  //   setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } })
  // }

  // const handleSaveClick = (id: GridRowId) => () => {
  //   setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } })
  // }

  // const handleDeleteClick = (id: GridRowId) => () => {
  //   console.log(parseInt(id.toString()) - 1, 'deleting')
  //   const rowToDelete = parseInt(id.toString()) - 1
  //   console.log('deleting', rows[rowToDelete].promo_code)
  //   setRows(
  //     rows.filter((row) => rows[rowToDelete].promo_code !== row.promo_code)
  //   )
  // }

  // const handleCancelClick = (id: GridRowId) => () => {
  //   setRowModesModel({
  //     ...rowModesModel,
  //     [id]: { mode: GridRowModes.View, ignoreModifications: true }
  //   })

  //   // const editedRow = rows.find((row) => row.voucherId === id)
  //   // // if (editedRow!.isNew) {
  //   // //   setRows(rows.filter((row) => row.promo_code !== id))
  //   // // }
  // }

  const processRowUpdate = (newRow: GridRowModel) => {
    const updatedRow = { ...newRow } as VoucherUploadRows
    setRows(
      //rows.map((row) => (row.voucherId === newRow.voucherId ? updatedRow : row))
      rows.map((row) => (row.code === newRow.code ? updatedRow : row))
    )
    return updatedRow
  }

  const COLUMNS: GridColumns = [
    {
      field: 'expiryAt',
      headerName: 'Expiry',
      width: 150,
      editable: true,
      cellClassName: (params) => {
        if (!params.value) {
          return 'batch-update-error'
        } else {
          return 'batch-update-ok'
        }
      }
    },
    {
      field: 'code',
      headerName: 'Promo Code',
      width: 150,
      editable: true,
      cellClassName: (params) => {
        if (!params.value) {
          return 'batch-update-error'
        } else {
          return 'batch-update-ok'
        }
      }
    },
    {
      field: 'currency',
      headerName: 'Currency',
      width: 150,
      editable: true,
      cellClassName: (params) => {
        if (!params.value) {
          return 'batch-update-error'
        } else {
          return 'batch-update-ok'
        }
      }
    },
    {
      field: 'value',
      headerName: 'Value',
      width: 150,
      editable: true,
      cellClassName: (params) => {
        if (!params.value) {
          return 'batch-update-error'
        } else {
          return 'batch-update-ok'
        }
      }
    },
    {
      field: 'symbol',
      headerName: 'Symbol',
      width: 150,
      editable: true,
      cellClassName: (params) => {
        if (!params.value) {
          return 'batch-update-error'
        } else {
          return 'batch-update-ok'
        }
      }
    },
    {
      field: 'partnerName',
      headerName: 'Partner Name',
      width: 150,
      editable: true,
      cellClassName: (params) => {
        if (!params.value) {
          return 'batch-update-error'
        } else {
          return 'batch-update-ok'
        }
      }
    }

    //temporarily disabling edit/delete functions
    // {
    //   field: 'action',
    //   type: 'actions',
    //   headerName: 'Actions',
    //   getActions: (params) => {
    //     const { id } = params

    //     const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit

    //     if (isInEditMode) {
    //       return [
    //         <GridActionsCellItem
    //           key={uuidv4()}
    //           icon={<SaveIcon />}
    //           label='Save'
    //           onClick={handleSaveClick(id)}
    //         />,
    //         <GridActionsCellItem
    //           key={uuidv4()}
    //           icon={<CancelIcon />}
    //           label='Cancel'
    //           className='textPrimary'
    //           onClick={handleCancelClick(id)}
    //           color='inherit'
    //         />
    //       ]
    //     }

    //     return [
    //       <GridActionsCellItem
    //         key={uuidv4()}
    //         icon={<EditIcon />}
    //         label='Edit'
    //         className='textPrimary'
    //         onClick={handleEditClick(id)}
    //         color='inherit'
    //       />,
    //       <GridActionsCellItem
    //         key={uuidv4()}
    //         disabled
    //         icon={<DeleteIcon />}
    //         label='Delete'
    //         onClick={handleDeleteClick(id)}
    //         color='inherit'
    //       />
    //     ]
    //   }
    // }
  ]

  return (
    <Box
      sx={{
        height: 500,
        width: '100%',
        '& .actions': {
          color: 'text.secondary'
        },
        '& .textPrimary': {
          color: 'text.primary'
        },
        '& .batch-update-error': {
          backgroundColor: '#d47483'
        },
        '& .batch-update-ok': {
          backgroundColor: 'rgba(157, 255, 118, 0.49)'
        }
      }}
    >
      <MUIDataGrid
        rows={rows}
        columns={COLUMNS}
        editMode='row'
        checkboxSelection
        isRowSelectable={(params: GridRowParams) => {
          const row: VoucherUploadRows = params.row

          return !!(
            row.expiryAt &&
            row.code &&
            row.currency &&
            row.value &&
            row.symbol &&
            row.partnerName
          )
        }}
        rowModesModel={rowModesModel}
        onRowEditStart={handleRowEditStart}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
        components={
          {
            //Toolbar: EditToolbar
          }
        }
        componentsProps={{
          toolbar: { setRows, setRowModesModel }
        }}
        experimentalFeatures={{ newEditingApi: true }}
      />
    </Box>
  )
}

// interface EditToolbarProps {
//   setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void
//   setRowModesModel: (
//     newModel: (oldModel: GridRowModesModel) => GridRowModesModel
//   ) => void
// }

interface ICRUDDataGrid {
  rows: VoucherUploadRows[]
  setRows: (rows: VoucherUploadRows[]) => void
}

export interface VoucherUploadRows {
  expiryAt: string
  code: string
  currency: string
  value: number
  symbol: string
  partnerName: string
}
